/* ══════════════════════════════════════════════════════════════
   One Piece Megamenu — no interactive elements needed currently.
   Scoped to .nav-item--one-piece only.
   New file — does not touch any existing theme JS.
   ══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';
  /* Placeholder — One Piece megamenu has no accordions or
     interactive widgets yet. File exists so theme.liquid can
     load it consistently alongside the CSS. */
})();
